import React from "react";
import style from "./Buttons.module.css";
export default function TextButton(props) {
  const { text, btnClass = "", ...restProps } = props;
  return (
    <button className={`${style.textBtn} ${btnClass}`} {...restProps}>
      {text}
    </button>
  );
}
